<p-toast key="common" 
    [showTransformOptions]="'translateY(100%)'" 
    [showTransformOptions]="'translateX(100%)'"
    [showTransitionOptions]="'250ms'" 
    [hideTransitionOptions]="'250ms'" 
    [breakpoints]="{'920px': {width: '100%', right: '0', left: '0'}}" 
    >
    <ng-template let-message pTemplate="message">
        @if(message.data?.notificationMethod === "showIncidentReportReviewNotification"){
            <lib-notification-feature-incident-review-notification [message]="message" [style]="{'width': '38rem'}" />
        }
        @else if(message.data?.notificationMethod === "showIncidentReportAssignmentNotification"){
            <lib-notification-feature-incident-assignment-notification [message]="message" [style]="{'width': '38rem'}" />
        }
        @else if(message.data?.notificationMethod === "showReleaseNoteNotification"){
            <lib-notification-release-note-notification [message]="message" [style]="{'width': '38rem'}" />
        }
        @else if(message.data?.notificationMethod === "showProblem") {
            <lib-notification-feature-system-notification [message]="message" [style]="{'width': '38rem'}" />
        }
        @else if(message.data?.notificationMethod === "showIntegrationNotification") {
            <lib-notification-feature-integration-notification [message]="message" [style]="{'width': '38rem'}" />
        }
        @else if(message.data?.notificationMethod === "showSystemMaintenanceCountdown") {
            <div class="flex items-start" style="width: 32rem">
                <span class="p-toast-message-icon mr-2" aria-hidden="true">
                <i class="pi pi-exclamation-triangle text-xl"></i>
                </span>

                <div class="p-toast-message-text flex flex-col gap-2">
                <div class="p-toast-summary">
                    {{ message.summary }}
                </div>

                <div class="p-toast-detail">
                    {{ message.data?.content?.primaryText }}
                </div>

                <div class="text-lg font-semibold">
                    {{ message.data?.countdownSeconds }} seconds remaining
                </div>
                </div>
            </div>
        }
        @else(){
            <span class="p-toast-message-icon mr-2" aria-hidden="true">
                <i class="pi pi-{{ message.data?.icon ?? 'info-circle'}} text-xl"></i>
            </span>
            <div class="p-toast-message-text" (click)="navigateToLink(message.data.link)" [class.cursor-pointer]="message.data?.link">
                <div class="p-toast-summary">{{ message.summary }}
                @if(message.data?.link){
                    <span class="text-primary"> - Open In New Tab</span>
                }
                </div>
                <div class="p-toast-detail">{{ message.detail }}</div>
            </div>
        }
    </ng-template>
</p-toast>